import { render } from "./TabContract.vue?vue&type=template&id=112eb7a3&ts=true"
import script from "./TabContract.vue?vue&type=script&lang=ts"
export * from "./TabContract.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__